import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ModalDrawer from './ModalDrawer.js';
import { useBugReport } from '../hooks/useBugReport';

const BugReportModal = ({ isOpen, onClose, theme, userId, isPro, isDemoMode, currentPage }) => {
    const { t } = useTranslation();
    const { submitReport, submitting } = useBugReport(userId, isPro ? 'pro' : 'free', isDemoMode, currentPage);

    const [message, setMessage] = useState('');
    const [feedback, setFeedback] = useState(null); // { type: 'success' | 'error', text }

    // Reset transient state whenever the modal (re)opens.
    useEffect(() => {
        if (isOpen) {
            setMessage('');
            setFeedback(null);
        }
    }, [isOpen]);

    const handleSubmit = async () => {
        const result = await submitReport(message);
        if (result.ok) {
            setFeedback({ type: 'success', text: t('bugReport.success') });
            setMessage('');
            return;
        }
        const key = result.reason === 'empty' ? 'bugReport.empty'
            : result.reason === 'demo' ? 'bugReport.demoDisabled'
            : 'bugReport.error';
        setFeedback({ type: 'error', text: t(key) });
    };

    const footer = (
        <>
            <button onClick={onClose} className="btn btn-ghost">{t('general.close')}</button>
            <button
                onClick={handleSubmit}
                className="btn btn-grad"
                disabled={submitting || !message.trim()}
            >
                {submitting ? t('bugReport.submitting') : t('bugReport.submit')}
            </button>
        </>
    );

    return (
        <ModalDrawer
            isOpen={isOpen}
            onClose={onClose}
            title={t('bugReport.title')}
            theme={theme}
            footer={footer}
            drawerId="bugReport"
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <p style={{ margin: 0, opacity: 0.8 }}>{t('bugReport.intro')}</p>
                <div className="form-group">
                    <label htmlFor="bug-report-message" className="form-label">{t('bugReport.label')}</label>
                    <textarea
                        id="bug-report-message"
                        className="form-input"
                        rows={6}
                        maxLength={2000}
                        value={message}
                        onChange={(e) => { setMessage(e.target.value); if (feedback) setFeedback(null); }}
                        placeholder={t('bugReport.placeholder')}
                        style={{ resize: 'vertical' }}
                    />
                </div>
                {feedback && (
                    <p role="status" className={`info-banner sm ${feedback.type === 'success' ? 'ok' : 'error'}`} style={{ margin: 0 }}>
                        {feedback.text}
                    </p>
                )}
            </div>
        </ModalDrawer>
    );
};

export default BugReportModal;
